'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var utils = require('../utils');
var triggerBlur = require('@mx/util/trigger-blur');
var keyboard = _interopDefault(require('../keyboard/instance'));
var clickoutside = _interopDefault(require('../directive/click-outside'));

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "custom-input-container"
    }, [_vm.title ? _c('div', {
      staticClass: "custom-input-title"
    }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "tap",
        rawName: "v-tap.all",
        modifiers: {
          "all": true
        }
      }, {
        name: "clickoutside",
        rawName: "v-clickoutside:touchstart",
        value: _vm.onBlur,
        expression: "onBlur",
        arg: "touchstart"
      }],
      staticClass: "custom-input",
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.onFocus($event);
        }
      }
    }, [_vm.sign ? _c('div', {
      staticClass: "custom-input-sign"
    }, [_vm._v(_vm._s(_vm.sign))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "custom-input-value"
    }, [_vm._v(_vm._s(_vm.formatValue))]), _vm._v(" "), _c('div', {
      staticClass: "custom-input-cursor",
      class: {
        blink: _vm.focus
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.value,
        expression: "!value"
      }],
      staticClass: "custom-input-placeholder"
    }, [_vm._v(" " + _vm._s(_vm.placeholder) + " ")])]), _vm._v(" "), _vm.errorMessage || _vm.tip ? _c('div', {
      class: ['custom-input-tip', {
        'custom-input-tip-error': _vm.errorMessage
      }]
    }, [_vm._v(" " + _vm._s(_vm.errorMessage || _vm.tip) + " ")]) : _vm._e()]);
  },
  staticRenderFns: [],
  name: 'custom-input',
  props: {
    value: {
      type: String,
      required: true
    },
    sign: {
      type: String,
      default: '$'
    },
    maxLength: {
      type: Number,
      default: 10
    },
    extraKey: {
      type: String,
      default: '.'
    },
    extraKeyRight: {
      type: String,
      default: ''
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    format: {
      type: Function
    },
    normalize: {
      type: Function
    },
    autoMoveUp: {
      type: Boolean
    },
    withButton: {
      type: Boolean
    },
    buttonText: {
      type: String
    },
    buttonEnabled: {
      type: Boolean
    },
    title: {
      type: String
    },
    tip: {
      type: String
    },
    errorMessage: {
      type: String
    },
    keyboardTip: {
      type: String,
      default: ''
    },
    paySafeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      focus: false
    };
  },
  watch: {
    buttonEnabled: function buttonEnabled() {
      keyboard.update({
        buttonEnabled: this.buttonEnabled
      });
    },
    value: function value() {
      this.updateKeyboardValue(this.value);
    }
  },
  computed: {
    formatValue: function formatValue() {
      if (this.format) {
        return this.format(this.value);
      } else {
        return this.value;
      }
    },
    root: function root() {
      var el = this.$el;

      while (el.parentElement && el.parentElement.tagName !== 'BODY') {
        el = el.parentElement;
      }

      return el;
    },
    elBottomToPageTop: function elBottomToPageTop() {
      return utils.sumOffsetTop(this.$el) + this.$el.offsetHeight;
    },
    keyboardTopToViewTop: function keyboardTopToViewTop() {
      var rem = window.innerWidth / 7.5;
      var keyboardHeight = (1.08 * 4 + 0.5) * rem + 2;
      return window.innerHeight - keyboardHeight;
    }
  },
  directives: {
    clickoutside: clickoutside
  },
  mounted: function mounted() {
    this.autoFocus && this.onFocus();
  },
  destroyed: function destroyed() {
    keyboard.hide();
  },
  methods: {
    normalizeInput: function normalizeInput(v) {
      if (this.normalize) {
        v = this.normalize(v);
      }

      this.$emit('input', v);
      return v;
    },
    showKeyboard: function showKeyboard() {
      var _this = this;

      this.focus = true;
      triggerBlur.triggerBlur();
      keyboard.show({
        value: this.value,
        extraKey: this.extraKey,
        maxLength: this.maxLength,
        withButton: this.withButton,
        buttonText: this.buttonText,
        buttonEnabled: this.buttonEnabled,
        extraKeyRight: this.extraKeyRight,
        keyboardTip: this.keyboardTip,
        paySafeInfo: this.paySafeInfo,
        onChange: function onChange(v) {
          return _this.normalizeInput(v);
        },
        onConfirm: function onConfirm() {
          _this.$emit('confirm');
        }
      });
    },
    updateKeyboardValue: function updateKeyboardValue(value) {
      keyboard.update({
        value: value
      });
    },
    moveUp: function moveUp(move) {
      var _this2 = this;

      if (!this.autoMoveUp) {
        return;
      }

      var elBottomToViewTop = this.elBottomToPageTop - window.scrollY;
      var needMove = move && elBottomToViewTop > this.keyboardTopToViewTop;

      if (needMove) {
        var dist = elBottomToViewTop - this.keyboardTopToViewTop;
        this.root.style.transform = "translateY(".concat(-dist, "px)");
        this.root.style.transition = '.3s .3s transform';
      } else {
        this.root.style.transform = '';
        window.setTimeout(function () {
          _this2.root.style.transition = '';
        }, 500);
      }
    },
    onFocus: function onFocus(e) {
      if (e && e.detail !== null) {
        return;
      }

      this.showKeyboard();
      this.moveUp(true);
      this.$emit('focus');
    },
    onBlur: function onBlur() {
      if (!this.focus) {
        return;
      }

      this.focus = false;
      this.moveUp(false);
      this.$emit('blur');
    }
  }
});

exports.default = index;
